/* Ulubione produkty.

   Lista uchwytow (handle) produktow w localStorage. Bez konta i bez aplikacji,
   wiec lista zyje w jednej przegladarce - tak samo jak na wiekszosci sklepow
   bez dedykowanej integracji.

   localStorage potrafi rzucic wyjatkiem (tryb prywatny, zablokowane dane
   witryny), dlatego kazdy dostep jest w try/catch, a przy braku pamieci serca
   nadal sie klikaja - tylko nic nie zapamietuja.
*/
(function () {
  var KLUCZ = 'ciroa_ulubione';

  function lista() {
    try {
      var surowe = window.localStorage.getItem(KLUCZ);
      if (!surowe) return [];
      var tablica = JSON.parse(surowe);
      return Array.isArray(tablica) ? tablica : [];
    } catch (e) {
      return [];
    }
  }

  function zapisz(tablica) {
    try {
      window.localStorage.setItem(KLUCZ, JSON.stringify(tablica));
    } catch (e) { /* brak pamieci - trudno */ }
  }

  function przelacz(handle) {
    var obecne = lista();
    var i = obecne.indexOf(handle);
    if (i === -1) obecne.push(handle);
    else obecne.splice(i, 1);
    zapisz(obecne);
    return i === -1;
  }

  function odswiezLicznik() {
    var ile = lista().length;
    var liczniki = document.querySelectorAll('[data-ulubione-licznik]');
    for (var i = 0; i < liczniki.length; i++) {
      liczniki[i].textContent = ile;
      liczniki[i].hidden = ile === 0;
    }
  }

  function ustawPrzycisk(przycisk, dodany) {
    /* Kazdy zapis sprawdzamy, czy cokolwiek zmienia. Bez tego podmiana
       textContent etykiety budzi MutationObserver nizej, ten znowu wola
       ustawPrzycisk - i karta produktu zawiesza przegladarke. */
    if (przycisk.getAttribute('aria-pressed') === (dodany ? 'true' : 'false')) return;
    przycisk.setAttribute('aria-pressed', dodany ? 'true' : 'false');
    przycisk.classList.toggle('ciroa-serce--aktywne', dodany);
    var etykieta = przycisk.querySelector('.ciroa-serce__etykieta');
    var nowyTekst = dodany ? 'W ulubionych' : 'Dodaj do ulubionych';
    if (etykieta && etykieta.textContent !== nowyTekst) etykieta.textContent = nowyTekst;
    var tytul = przycisk.getAttribute('aria-label') || '';
    var nazwa = tytul.replace(/^(Dodaj do ulubionych|Usuń z ulubionych): /, '');
    var nowaEtykieta = (dodany ? 'Usuń z ulubionych: ' : 'Dodaj do ulubionych: ') + nazwa;
    if (tytul !== nowaEtykieta) przycisk.setAttribute('aria-label', nowaEtykieta);
  }

  function odswiezSerca(zasieg) {
    var obecne = lista();
    var serca = (zasieg || document).querySelectorAll('[data-ulubione]');
    for (var i = 0; i < serca.length; i++) {
      ustawPrzycisk(serca[i], obecne.indexOf(serca[i].getAttribute('data-ulubione')) !== -1);
    }
  }

  /* Delegacja zdarzen - kafelki doklejaja sie dynamicznie (filtry, paginacja,
     szybki podglad), wiec nasluch musi siedziec na dokumencie. */
  document.addEventListener('click', function (e) {
    var przycisk = e.target.closest ? e.target.closest('[data-ulubione]') : null;
    if (!przycisk) return;
    e.preventDefault();
    e.stopPropagation();
    var dodany = przelacz(przycisk.getAttribute('data-ulubione'));
    ustawPrzycisk(przycisk, dodany);
    odswiezLicznik();
    document.dispatchEvent(new CustomEvent('ciroa:ulubione', { detail: { handle: przycisk.getAttribute('data-ulubione'), dodany: dodany } }));
  });

  document.addEventListener('DOMContentLoaded', function () {
    odswiezSerca();
    odswiezLicznik();
  });

  /* Liste zmienia tez strona /pages/ulubione (przycisk "Usuń"). Tamtejszy
     skrypt zglasza to zdarzeniem, zeby licznik w naglowku i serca na innych
     sekcjach tej samej strony zgadzaly sie z pamiecia. */
  document.addEventListener('ciroa:ulubione', function () {
    odswiezSerca();
    odswiezLicznik();
  });

  /* Filtry kolekcji podmieniaja siatke przez Section Rendering API - wtedy
     nowe serca trzeba ustawic jeszcze raz. Obserwujemy tylko siatki produktow,
     nie cale body: mniej pracy i zaden nasz wlasny zapis nie wraca do nas. */
  var oczekuje = false;
  var obserwator = new MutationObserver(function () {
    if (oczekuje) return;
    oczekuje = true;
    window.requestAnimationFrame(function () {
      oczekuje = false;
      odswiezSerca();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var siatki = document.querySelectorAll('#product-grid, .collection .grid, .complementary-products, .product-recommendations');
    for (var i = 0; i < siatki.length; i++) {
      obserwator.observe(siatki[i], { childList: true, subtree: true });
    }
  });

  window.ciroaUlubione = { lista: lista, odswiezSerca: odswiezSerca };
})();
